import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useEffect, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { _get, _query, isHttpWithData } from "noood/net/xhr";
import Skeleton from "noood/comp/skeleton/Skeleton";
import Flex from "noood/comp/ui/containers/Flex";
import Icon from "noood/comp/ui/feather-icon/Icon";
import Text from "noood/comp/text/Text";
import SpinnerApple from "noood/comp/ui/spinner/Spinner.Apple";
import Spacer from "noood/comp/ui/spacer/Spacer";
import { NavLink } from "react-router-dom";
import SimpleCheckbox from "noood/comp/checkbox/SimpleCheckbox";
import TableSearchBar from "noood/comp/data/table/TableSearchBar";
import { string_util } from "noood/util/string/StringUtil";
export default function Table(props) {
  var _props$paging$per_pag, _props$paging, _ref, _cols$filter, _list$length;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    list = _useState2[0],
    setList = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    page = _useState4[0],
    setPage = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    paging = _useState6[0],
    setPaging = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    isFetching = _useState8[0],
    setIsFetching = _useState8[1];
  var _useState9 = useState(),
    _useState0 = _slicedToArray(_useState9, 2),
    filterObj = _useState0[0],
    setFilterObj = _useState0[1];
  var cols = props.cols;
  var perPage = (_props$paging$per_pag = (_props$paging = props.paging) === null || _props$paging === void 0 ? void 0 : _props$paging.per_page) !== null && _props$paging$per_pag !== void 0 ? _props$paging$per_pag : 10;
  var pages = (_ref = (paging === null || paging === void 0 ? void 0 : paging.total_count) && Math.ceil((paging === null || paging === void 0 ? void 0 : paging.total_count) / perPage)) !== null && _ref !== void 0 ? _ref : 0;
  var hasNext = page < pages;
  var hasPrevious = page > 1;
  var hasData = (list === null || list === void 0 ? void 0 : list.length) >= 0;
  var hasRecords = (list === null || list === void 0 ? void 0 : list.length) > 0;
  var hasFilter = ((_cols$filter = cols.filter(function (col) {
    return col.filterType !== void 0 && col.filterType !== null;
  })) === null || _cols$filter === void 0 ? void 0 : _cols$filter.length) > 0;
  var __next = function __next() {
    if (!isFetching) setPage(page + 1);
  };
  var __prev = function __prev() {
    if (!isFetching) setPage(page - 1);
  };
  var __first = function __first() {
    if (!isFetching && page !== 1) {
      setPage(1);
    }
  };
  var __last = function __last() {
    if (!isFetching && page !== pages) {
      setPage(pages);
    }
  };
  var __traverse = function __traverse(_ref2) {
    var obj = _ref2.obj,
      prop = _ref2.prop;
    if (prop.indexOf("\.") > -1) {
      return prop.split('.').reduce(function (current, key) {
        return current === null || current === void 0 ? void 0 : current[key];
      }, obj);
    } else {
      return obj[prop];
    }
  };
  var __fetch = function __fetch() {
    if (typeof props.data_source === 'string') {
      setIsFetching(true);
      if (props.useQuery) {
        var _props$paging2;
        var fragment = {
          n: perPage,
          x: page
        };
        if (((_props$paging2 = props.paging) === null || _props$paging2 === void 0 || (_props$paging2 = _props$paging2.sorters) === null || _props$paging2 === void 0 ? void 0 : _props$paging2.length) > 0) {
          fragment.s = props.paging.sorters.map(function (sorter) {
            var _sorter$isAsc;
            return {
              property: sorter.property,
              isAsc: (_sorter$isAsc = sorter.isAsc) !== null && _sorter$isAsc !== void 0 ? _sorter$isAsc : true
            };
          });
        }
        if (filterObj && JSON.stringify(filterObj) !== '{}') {
          fragment.f = Object.keys(filterObj).filter(function (k) {
            return filterObj[k];
          }).map(function (k) {
            var _filterObj$k$value;
            return {
              property: k,
              value: encodeURIComponent((_filterObj$k$value = filterObj[k].value) === null || _filterObj$k$value === void 0 ? void 0 : _filterObj$k$value.toString()),
              comparator: filterObj[k].comparator
            };
          });
        }
        _query(props.data_source, fragment, function (res) {
          var _isHttpWithData;
          setIsFetching(false);
          setList((_isHttpWithData = isHttpWithData(res)) !== null && _isHttpWithData !== void 0 ? _isHttpWithData : []);
          setPaging(res.paging);
        });
      } else {
        var _props$paging3;
        var queryString = new URLSearchParams();
        queryString.set('n', perPage.toString());
        queryString.set('x', page === null || page === void 0 ? void 0 : page.toString());
        if (((_props$paging3 = props.paging) === null || _props$paging3 === void 0 || (_props$paging3 = _props$paging3.sorters) === null || _props$paging3 === void 0 ? void 0 : _props$paging3.length) > 0) {
          var sorterStr = props.paging.sorters.map(function (sorter) {
            return "".concat(sorter.property).concat(sorter.isAsc ? '' : ':desc');
          }).join(',');
          queryString.set('s', sorterStr);
        }
        if (filterObj && JSON.stringify(filterObj) !== '{}') {
          var toQueryString = Object.keys(filterObj).reduce(function (filter, k) {
            if (filterObj[k]) {
              var _filterObj$k$value2;
              var finalFilterValue = (_filterObj$k$value2 = filterObj[k].value) === null || _filterObj$k$value2 === void 0 ? void 0 : _filterObj$k$value2.toString();
              console.log("finalFiltervalue: ", finalFilterValue);
              filter.push("".concat(k, "~~").concat(encodeURIComponent(finalFilterValue), "~~").concat(filterObj[k].comparator));
            }
            return filter;
          }, []);
          if ((toQueryString === null || toQueryString === void 0 ? void 0 : toQueryString.length) > 0) {
            queryString.set('f', encodeURIComponent(toQueryString.join("::")));
          }
        } else {
          queryString["delete"]('f');
        }
        var qsString = queryString.toString();
        var separator = props.data_source.includes('?') ? '&' : '?';
        _get("".concat(props.data_source).concat((qsString === null || qsString === void 0 ? void 0 : qsString.length) > 0 ? "".concat(separator).concat(qsString) : ""), function (res) {
          var _isHttpWithData2;
          setIsFetching(false);
          setList((_isHttpWithData2 = isHttpWithData(res)) !== null && _isHttpWithData2 !== void 0 ? _isHttpWithData2 : []);
          setPaging(res.paging);
        });
      }
    } else {
      var _props$data_source$le, _props$data_source;
      setList(props.data_source);
      setPaging({
        total_count: (_props$data_source$le = (_props$data_source = props.data_source) === null || _props$data_source === void 0 ? void 0 : _props$data_source.length) !== null && _props$data_source$le !== void 0 ? _props$data_source$le : 0
      });
    }
  };
  useEffect(function () {
    if (props.data_source && page) {
      __fetch();
    }
  }, [page, props.data_source]);
  useEffect(function () {
    if (filterObj) {
      if (page === 1) {
        __fetch();
      } else {
        setPage(1);
      }
    }
  }, [filterObj]);

  /*if (list !== void 0 && list !== null && list.length === 0) {
    return <>No records found.</>
  }*/

  return /*#__PURE__*/React.createElement(React.Fragment, null, hasFilter && /*#__PURE__*/React.createElement(TableSearchBar, _extends({}, props, {
    list: list,
    isFetching: isFetching,
    __onSearch: function __onSearch(searchFilterObj) {
      setFilterObj(searchFilterObj);
    }
  })), (cols === null || cols === void 0 ? void 0 : cols.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "Table__ui.header ev1kd3s2o ev14odnwx ev78zum5 ev1afdwag"
  }, props.selectable && /*#__PURE__*/React.createElement("div", {
    style: {
      width: 25
    }
  }, /*#__PURE__*/React.createElement(SimpleCheckbox, null)), cols.map(function (col, idx) {
    var _col$label;
    return /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.col_header, col.visibleInWeb === false && ui.hidden_in_web, col.alignRight && ui.flush_right), {
      style: {
        flex: col.width ? "unset" : 1,
        width: col.width ? typeof col.width === 'string' ? col.width : "".concat(col.width, "px") : undefined
      }
    }), (_col$label = col.label) !== null && _col$label !== void 0 ? _col$label : string_util.uc_words(col.property, '_'));
  })), !hasRecords && !isFetching && /*#__PURE__*/React.createElement("div", {
    className: "Table__ui.no_records evji57aj evjjci79 ev78zum5 ev6s0dn4 evl56j7k"
  }, "No records"), (list !== null && list !== void 0 ? list : Array((_list$length = list === null || list === void 0 ? void 0 : list.length) !== null && _list$length !== void 0 ? _list$length : perPage).fill(0)).map(function (o, idx) {
    return /*#__PURE__*/React.createElement("div", stylex.props(ui.row, idx % 2 === 0 ? ui.row_odd : ui.row_even), props.selectable && /*#__PURE__*/React.createElement("div", {
      style: {
        width: 25,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, hasData ? /*#__PURE__*/React.createElement(SimpleCheckbox, null) : /*#__PURE__*/React.createElement(Skeleton, {
      height: 16,
      width: 16,
      borderRadius: 3
    })), cols.map(function (col) {
      var _props$rowPadding, _props$rowPadding2, _col$label2;
      return /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.col_wrapper, col.visibleInWeb === false && ui.hidden_in_web), {
        style: {
          flex: col.width ? "unset" : 1,
          paddingTop: (_props$rowPadding = props.rowPadding) !== null && _props$rowPadding !== void 0 ? _props$rowPadding : 5,
          paddingBottom: (_props$rowPadding2 = props.rowPadding) !== null && _props$rowPadding2 !== void 0 ? _props$rowPadding2 : 5,
          width: col.width ? typeof col.width === 'string' ? col.width : "".concat(col.width, "px") : undefined
        }
      }), (col.showFieldInMobile === void 0 || col.showFieldInMobile === true) && /*#__PURE__*/React.createElement("div", {
        className: "Table__ui.mobile_label ev141qb35 evjehfbx evxgkjg2"
      }, (_col$label2 = col.label) !== null && _col$label2 !== void 0 ? _col$label2 : col.property), /*#__PURE__*/React.createElement("div", stylex.props(ui.col, col.alignRight && ui.flush_right, col.isMonospace && ui.monospace), col.to ? /*#__PURE__*/React.createElement(React.Fragment, null, hasData ? /*#__PURE__*/React.createElement(NavLink, {
        to: col.to(o, idx)
      }, col.content ? col.content(o, idx) : __traverse({
        obj: o,
        prop: col.property
      })) : /*#__PURE__*/React.createElement(Skeleton, {
        height: 14,
        width: "70%"
      })) : /*#__PURE__*/React.createElement(React.Fragment, null, hasData ? /*#__PURE__*/React.createElement(React.Fragment, null, col.content ? col.content(o, idx) : __traverse({
        obj: o,
        prop: col.property
      })) : /*#__PURE__*/React.createElement(Skeleton, {
        height: 14,
        width: "80%"
      }))));
    }));
  }), (props.showPaging === void 0 || props.showPaging) && /*#__PURE__*/React.createElement(Flex, {
    style: {
      padding: 5,
      marginTop: 5
    },
    gap: 5,
    stylex: [ui.controls]
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }), isFetching && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SpinnerApple, null)), hasRecords ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    secondary: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, page * perPage - (perPage - 1), "-", page * perPage > (paging === null || paging === void 0 ? void 0 : paging.total_count) ? paging === null || paging === void 0 ? void 0 : paging.total_count : page * perPage, "\xA0of ", paging === null || paging === void 0 ? void 0 : paging.total_count))) : hasData ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(Skeleton, {
    height: 14,
    width: 15,
    borderRadius: 3
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("button", _extends({
    disabled: !hasPrevious || isFetching || page === 1,
    onClick: function onClick() {
      __first();
    }
  }, {
    className: "Table__ui.button ev1h2kqdt ev1wty727 evhw01xz evznzmgi ev1catss evaa06q2 ev1ypdohk evji57aj ev14abgrs ev1ko5yus ev1yivw0v evzfsiqg evb5qqna ev1s07b3s"
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: "chevrons-left",
    size: 20,
    color: isFetching || !hasPrevious || page === 1 ? 'var(--shade-05)' : "var(--shade-60)"
  })), /*#__PURE__*/React.createElement("button", _extends({
    disabled: !hasPrevious || isFetching,
    onClick: function onClick() {
      __prev();
    }
  }, {
    className: "Table__ui.button ev1h2kqdt ev1wty727 evhw01xz evznzmgi ev1catss evaa06q2 ev1ypdohk evji57aj ev14abgrs ev1ko5yus ev1yivw0v evzfsiqg evb5qqna ev1s07b3s"
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: "chevron-left",
    size: 20,
    color: isFetching || !hasPrevious ? 'var(--shade-05)' : "var(--shade-60)"
  })), /*#__PURE__*/React.createElement("button", _extends({
    disabled: !hasNext || isFetching,
    onClick: function onClick() {
      __next();
    }
  }, {
    className: "Table__ui.button ev1h2kqdt ev1wty727 evhw01xz evznzmgi ev1catss evaa06q2 ev1ypdohk evji57aj ev14abgrs ev1ko5yus ev1yivw0v evzfsiqg evb5qqna ev1s07b3s"
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: "chevron-right",
    size: 20,
    color: isFetching || !hasNext ? 'var(--shade-05)' : "var(--shade-60)"
  })), /*#__PURE__*/React.createElement("button", _extends({
    disabled: !hasNext || isFetching || page === pages,
    onClick: function onClick() {
      __last();
    }
  }, {
    className: "Table__ui.button ev1h2kqdt ev1wty727 evhw01xz evznzmgi ev1catss evaa06q2 ev1ypdohk evji57aj ev14abgrs ev1ko5yus ev1yivw0v evzfsiqg evb5qqna ev1s07b3s"
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: "chevrons-right",
    size: 20,
    color: isFetching || !hasNext || page === pages ? 'var(--shade-05)' : "var(--shade-60)"
  }))))), props.space && /*#__PURE__*/React.createElement(Spacer, {
    mtop: props.space
  }), /*#__PURE__*/React.createElement("div", {
    className: "Table__ui.mobile_margin ev1kf18lf"
  }));
}
var SkeletonRow = function SkeletonRow(props) {
  var cols = props.cols,
    idx = props.idx;
  return /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.row, idx % 2 === 0 ? ui.row_even : ui.row_odd), {
    style: _objectSpread({
      padding: 5
    }, props.style)
  }), cols === null || cols === void 0 ? void 0 : cols.map(function (col) {
    var _col$label3;
    return /*#__PURE__*/React.createElement("div", _extends({}, {
      className: "Table__ui.col_wrapper ev1fzcu0k ev1rofl7t evwe5tzs ev18bpqsy ev5vhmuc evl317c6 ev1be37p evuxlx0m ev12h1fpx ev18hgqmr ev1iwywzk ev1x076xq ev1pd2b8k"
    }, {
      style: {
        flex: col.width ? "unset" : 1,
        width: col.width ? typeof col.width === 'string' ? col.width : "".concat(col.width, "px") : undefined
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "Table__ui.mobile_label ev141qb35 evjehfbx evxgkjg2"
    }, (_col$label3 = col.label) !== null && _col$label3 !== void 0 ? _col$label3 : col.property), /*#__PURE__*/React.createElement("div", {
      className: "Table__ui.col ev14odnwx ev1yn0g08 evif65rj ev98rzlu evyzsjq7"
    }, /*#__PURE__*/React.createElement(Skeleton, {
      height: 14,
      width: "50%"
    })));
  }));
};

// @ts-ignore
_inject(".ev14odnwx{padding:5px}", 1000);
_inject(".ev1yn0g08{word-break:break-all}", 3000);
_inject(".evif65rj{font-size:14px}", 3000);
_inject(".ev98rzlu{flex:1}", 2000);
_inject("@media(max-width:500px){.evyzsjq7.evyzsjq7{width:100%}}", 4200);
_inject("@media(min-width:501px){.ev141qb35.ev141qb35{display:none}}", 3200);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject("@media(max-width: 500px){.ev1ge25ea.ev1ge25ea{flex-direction:column}}", 3200);
_inject("@media(max-width: 500px){.evo8powt.evo8powt{align-items:flex-start}}", 3200);
_inject("@media(max-width: 500px){.evd69554.evd69554{border:1px solid var(--shade-10)}}", 1200);
_inject("@media(max-width: 500px){.evz0bwv8.evz0bwv8{border-radius:10px}}", 2200);
_inject("@media(max-width: 500px){.evdkhkxb.evdkhkxb{margin:10px}}", 1200);
_inject(".ev1m3phxg{transition:background-color .1s}", 2000);
_inject(".ev3dtjww:hover{background-color:var(--shade-10)}", 3130);
_inject("@media(min-width:501px){.ev121rd8y.ev121rd8y{border-bottom:1px solid var(--shade-10)}}", 2200);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".ev1kd3s2o{background-color:var(--shade-20)}", 3000);
_inject("@media(max-width:500px){.ev1afdwag.ev1afdwag{display:none}}", 3200);
_inject("@media(max-width:500px){.evjehfbx.evjehfbx{color:var(--shade-40)}}", 3200);
_inject("@media(max-width:500px){.evxgkjg2.evxgkjg2{font-size:.9rem}}", 3200);
_inject("@media(max-width: 500px){.ev1fzcu0k.ev1fzcu0k{display:flex}}", 3200);
_inject("@media(max-width: 500px){.ev1rofl7t.ev1rofl7t{width:100%!important}}", 4200);
_inject("@media(max-width: 500px){.evwe5tzs.evwe5tzs{align-items:center}}", 3200);
_inject("@media(max-width: 500px){.ev18bpqsy.ev18bpqsy{flex:unset}}", 2200);
_inject("@media(max-width: 500px){.ev5vhmuc.ev5vhmuc{flex-wrap:wrap}}", 3200);
_inject("@media(max-width: 500px){.evl317c6.evl317c6{padding:3px 5px}}", 1200);
_inject("@media(max-width: 500px){.ev1be37p.ev1be37p:nth-child(odd){background-color:var(--shade-10)}}", 3260);
_inject("@media(max-width: 500px){.evuxlx0m.evuxlx0m:nth-child(even){background-color:var(--shade-05)}}", 3260);
_inject("@media(max-width: 500px){.ev12h1fpx.ev12h1fpx:nth-child(1){border-top-left-radius:10px}}", 4260);
_inject("@media(max-width: 500px){.ev18hgqmr.ev18hgqmr:nth-child(1){border-top-right-radius:10px}}", 4260);
_inject("@media(max-width: 500px){.ev1iwywzk.ev1iwywzk:nth-last-child(1){border-bottom-left-radius:10px}}", 4261);
_inject("@media(max-width: 500px){.ev1x076xq.ev1x076xq:nth-last-child(1){border-bottom-right-radius:10px}}", 4261);
_inject("@media(min-width:501px){.ev1pd2b8k.ev1pd2b8k{display:flex}}", 3200);
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".ev1wty727{border:0}", 1000);
_inject(".evhw01xz:first-of-type{border-top-left-radius:7px}", 4053);
_inject(".evznzmgi:first-of-type{border-bottom-left-radius:7px}", 4053);
_inject(".ev1catss:last-of-type{border-top-right-radius:7px}", 4055);
_inject(".evaa06q2:last-of-type{border-bottom-right-radius:7px}", 4055);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".evji57aj{background-color:var(--shade-10)}", 3000);
_inject(".ev14abgrs:hover{background-color:var(--shade-15)}", 3130);
_inject(".ev1ko5yus:active{background-color:var(--shade-20)}", 3170);
_inject(".ev1yivw0v:disabled{background-color:var(--shade-10)}", 3092);
_inject(".evzfsiqg:disabled:hover{background-color:var(--shade-10)}", 3222);
_inject(".evb5qqna:active:disabled{background-color:var(--shade-10)}", 3262);
_inject(".ev1s07b3s:disabled{cursor:not-allowed}", 3092);
_inject("@media(max-width:500px){.evneakk3.evneakk3{margin:10px}}", 1200);
_inject("@media(max-width:500px){.ev1kf18lf.ev1kf18lf{margin-bottom:70px}}", 4200);
_inject(".evjjci79{min-height:250px}", 4000);
_inject(".evl56j7k{justify-content:center}", 3000);
_inject(".ev13a6bvl{justify-content:flex-end}", 3000);
_inject(".evcicffo{padding-right:10px}", 4000);
_inject(".ev19ofvfr{font-family:mono}", 3000);
var ui = {
  col: {
    "Table__ui.col": "Table__ui.col",
    padding: "ev14odnwx",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    wordBreak: "ev1yn0g08",
    fontSize: "evif65rj",
    flex: "ev98rzlu",
    flexGrow: null,
    flexShrink: null,
    flexBasis: null,
    "@media(max-width:500px)_width": "evyzsjq7",
    $$css: true
  },
  hidden_in_web: {
    "Table__ui.hidden_in_web": "Table__ui.hidden_in_web",
    "@media(min-width:501px)_display": "ev141qb35",
    $$css: true
  },
  row: {
    "Table__ui.row": "Table__ui.row",
    display: "ev78zum5",
    alignItems: "ev6s0dn4",
    "@media(max-width: 500px)_flexDirection": "ev1ge25ea",
    "@media(max-width: 500px)_alignItems": "evo8powt",
    "@media(max-width: 500px)_border": "evd69554",
    "@media(max-width: 500px)_borderWidth": null,
    "@media(max-width: 500px)_borderInlineWidth": null,
    "@media(max-width: 500px)_borderInlineStartWidth": null,
    "@media(max-width: 500px)_borderLeftWidth": null,
    "@media(max-width: 500px)_borderInlineEndWidth": null,
    "@media(max-width: 500px)_borderRightWidth": null,
    "@media(max-width: 500px)_borderBlockWidth": null,
    "@media(max-width: 500px)_borderTopWidth": null,
    "@media(max-width: 500px)_borderBottomWidth": null,
    "@media(max-width: 500px)_borderStyle": null,
    "@media(max-width: 500px)_borderInlineStyle": null,
    "@media(max-width: 500px)_borderInlineStartStyle": null,
    "@media(max-width: 500px)_borderLeftStyle": null,
    "@media(max-width: 500px)_borderInlineEndStyle": null,
    "@media(max-width: 500px)_borderRightStyle": null,
    "@media(max-width: 500px)_borderBlockStyle": null,
    "@media(max-width: 500px)_borderTopStyle": null,
    "@media(max-width: 500px)_borderBottomStyle": null,
    "@media(max-width: 500px)_borderColor": null,
    "@media(max-width: 500px)_borderInlineColor": null,
    "@media(max-width: 500px)_borderInlineStartColor": null,
    "@media(max-width: 500px)_borderLeftColor": null,
    "@media(max-width: 500px)_borderInlineEndColor": null,
    "@media(max-width: 500px)_borderRightColor": null,
    "@media(max-width: 500px)_borderBlockColor": null,
    "@media(max-width: 500px)_borderTopColor": null,
    "@media(max-width: 500px)_borderBottomColor": null,
    "@media(max-width: 500px)_borderRadius": "evz0bwv8",
    "@media(max-width: 500px)_borderStartStartRadius": null,
    "@media(max-width: 500px)_borderStartEndRadius": null,
    "@media(max-width: 500px)_borderEndStartRadius": null,
    "@media(max-width: 500px)_borderEndEndRadius": null,
    "@media(max-width: 500px)_borderTopLeftRadius": null,
    "@media(max-width: 500px)_borderTopRightRadius": null,
    "@media(max-width: 500px)_borderBottomLeftRadius": null,
    "@media(max-width: 500px)_borderBottomRightRadius": null,
    "@media(max-width: 500px)_margin": "evdkhkxb",
    "@media(max-width: 500px)_marginInline": null,
    "@media(max-width: 500px)_marginInlineStart": null,
    "@media(max-width: 500px)_marginLeft": null,
    "@media(max-width: 500px)_marginInlineEnd": null,
    "@media(max-width: 500px)_marginRight": null,
    "@media(max-width: 500px)_marginBlock": null,
    "@media(max-width: 500px)_marginTop": null,
    "@media(max-width: 500px)_marginBottom": null,
    transition: "ev1m3phxg",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    ":hover_backgroundColor": "ev3dtjww",
    "@media(min-width:501px)_borderBottom": "ev121rd8y",
    "@media(min-width:501px)_borderBottomWidth": null,
    "@media(min-width:501px)_borderBottomStyle": null,
    "@media(min-width:501px)_borderBottomColor": null,
    $$css: true
  },
  row_odd: {
    "Table__ui.row_odd": "Table__ui.row_odd",
    backgroundColor: "ev1y7ric0",
    $$css: true
  },
  row_even: {
    "Table__ui.row_even": "Table__ui.row_even",
    backgroundColor: "ev1y7ric0",
    $$css: true
  },
  col_wrapper: {
    "Table__ui.col_wrapper": "Table__ui.col_wrapper",
    "@media(max-width: 500px)_display": "ev1fzcu0k",
    "@media(max-width: 500px)_width": "ev1rofl7t",
    "@media(max-width: 500px)_alignItems": "evwe5tzs",
    "@media(max-width: 500px)_flex": "ev18bpqsy",
    "@media(max-width: 500px)_flexGrow": null,
    "@media(max-width: 500px)_flexShrink": null,
    "@media(max-width: 500px)_flexBasis": null,
    "@media(max-width: 500px)_flexWrap": "ev5vhmuc",
    "@media(max-width: 500px)_padding": "evl317c6",
    "@media(max-width: 500px)_paddingInline": null,
    "@media(max-width: 500px)_paddingStart": null,
    "@media(max-width: 500px)_paddingLeft": null,
    "@media(max-width: 500px)_paddingEnd": null,
    "@media(max-width: 500px)_paddingRight": null,
    "@media(max-width: 500px)_paddingBlock": null,
    "@media(max-width: 500px)_paddingTop": null,
    "@media(max-width: 500px)_paddingBottom": null,
    "@media(max-width: 500px)_:nth-child(odd)_backgroundColor": "ev1be37p",
    "@media(max-width: 500px)_:nth-child(even)_backgroundColor": "evuxlx0m",
    "@media(max-width: 500px)_:nth-child(1)_borderTopLeftRadius": "ev12h1fpx",
    "@media(max-width: 500px)_:nth-child(1)_borderStartStartRadius": null,
    "@media(max-width: 500px)_:nth-child(1)_borderStartEndRadius": null,
    "@media(max-width: 500px)_:nth-child(1)_borderTopRightRadius": "ev18hgqmr",
    "@media(max-width: 500px)_:nth-last-child(1)_borderBottomLeftRadius": "ev1iwywzk",
    "@media(max-width: 500px)_:nth-last-child(1)_borderEndStartRadius": null,
    "@media(max-width: 500px)_:nth-last-child(1)_borderEndEndRadius": null,
    "@media(max-width: 500px)_:nth-last-child(1)_borderBottomRightRadius": "ev1x076xq",
    "@media(min-width:501px)_display": "ev1pd2b8k",
    $$css: true
  },
  controls: {
    "Table__ui.controls": "Table__ui.controls",
    "@media(max-width:500px)_margin": "evneakk3",
    "@media(max-width:500px)_marginInline": null,
    "@media(max-width:500px)_marginInlineStart": null,
    "@media(max-width:500px)_marginLeft": null,
    "@media(max-width:500px)_marginInlineEnd": null,
    "@media(max-width:500px)_marginRight": null,
    "@media(max-width:500px)_marginBlock": null,
    "@media(max-width:500px)_marginTop": null,
    "@media(max-width:500px)_marginBottom": null,
    $$css: true
  },
  flush_right: {
    "Table__ui.flush_right": "Table__ui.flush_right",
    display: "ev78zum5",
    justifyContent: "ev13a6bvl",
    paddingRight: "evcicffo",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    $$css: true
  },
  monospace: {
    "Table__ui.monospace": "Table__ui.monospace",
    fontFamily: "ev19ofvfr",
    $$css: true
  }
};